(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-sw-dismiss]').forEach((button) => {
    const target = document.querySelector(button.getAttribute('data-sw-dismiss'));
    if (!target) return;
    const key = target.dataset.storageKey;
    if (key && localStorage.getItem(key) === 'hidden') target.hidden = true;
    button.addEventListener('click', () => {
      if (target.classList.contains('is-closing')) return;
      let closed = false;
      const finish = () => {
        if (closed) return;
        closed = true;
        target.hidden = true;
        target.classList.remove('is-closing');
        if (key) localStorage.setItem(key, 'hidden');
      };
      target.classList.add('is-closing');
      target.addEventListener('animationend', finish, { once: true });
      window.setTimeout(finish, reduceMotion ? 0 : 360);
    });
  });

  document.querySelectorAll('[data-sw-slider]').forEach((slider) => {
    slider.querySelectorAll('[data-sw-slider-prev], [data-sw-slider-next]').forEach((button) => {
      button.addEventListener('click', () => {
        const scroller = slider.querySelector('[data-sw-slider-track]');
        if (!scroller) return;
        const direction = button.hasAttribute('data-sw-slider-next') ? 1 : -1;
        scroller.scrollBy({ left: direction * scroller.clientWidth * 0.86, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  });

  const initializeContinuousMarquees = () => {
    document.querySelectorAll('.sw-continuous-marquee:not(.sw-continuous-marquee--static)').forEach((marquee) => {
      const viewport = marquee.querySelector('.sw-continuous-marquee__viewport');
      const track = marquee.querySelector('.sw-continuous-marquee__track');
      const sourceGroup = track?.querySelector('[data-sw-marquee-group]');
      if (!viewport || !track || !sourceGroup) return;

      track.querySelectorAll('[data-sw-marquee-clone]').forEach((clone) => clone.remove());
      const groupWidth = Math.ceil(sourceGroup.getBoundingClientRect().width);
      if (!groupWidth) return;

      // Cover at least two viewports beyond the source group so the loop never
      // reveals an empty run, regardless of the number or length of messages.
      const requiredWidth = viewport.clientWidth * 2 + groupWidth;
      let renderedWidth = groupWidth;
      while (renderedWidth < requiredWidth) {
        const clone = sourceGroup.cloneNode(true);
        clone.removeAttribute('data-sw-marquee-group');
        clone.setAttribute('data-sw-marquee-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('role', 'presentation');
        clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
        renderedWidth += groupWidth;
      }

      track.style.setProperty('--sw-marquee-distance', `-${groupWidth}px`);
    });
  };

  const scheduleContinuousMarqueeLayout = () => requestAnimationFrame(initializeContinuousMarquees);
  window.addEventListener('resize', scheduleContinuousMarqueeLayout, { passive: true });
  window.addEventListener('load', scheduleContinuousMarqueeLayout, { once: true });
  scheduleContinuousMarqueeLayout();

  document.querySelectorAll('[data-sw-panel-slider]').forEach((slider) => {
    const scroller = slider.querySelector('[data-sw-panel-track]');
    const prev = slider.querySelector('[data-sw-panel-prev]');
    const next = slider.querySelector('[data-sw-panel-next]');
    slider.querySelectorAll('[data-sw-product-info-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.swProductInfoTab;
        slider.querySelectorAll('[data-sw-product-info-tab]').forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        slider.querySelectorAll('[data-sw-product-info-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.swProductInfoPanel !== target;
        });
      });
    });
    if (!scroller || !prev || !next) return;

    const syncControls = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const canScroll = maxScroll > 2;
      slider.classList.toggle('can-scroll', canScroll);
      slider.classList.toggle('is-at-start', scroller.scrollLeft <= 2);
      slider.classList.toggle('is-at-end', scroller.scrollLeft >= maxScroll - 2);
    };

    const scrollTabs = (direction) => {
      scroller.scrollBy({ left: direction * scroller.clientWidth * 0.72, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    prev.addEventListener('click', () => scrollTabs(-1));
    next.addEventListener('click', () => scrollTabs(1));
    scroller.addEventListener('scroll', syncControls, { passive: true });
    window.addEventListener('resize', syncControls);
    syncControls();
  });

  const desktopMegaQuery = window.matchMedia('(min-width: 990px)');
  const megaMenus = Array.from(document.querySelectorAll('.header__inline-menu details.mega-menu'));

  const closeMegaMenu = (details) => {
    if (!details) return;
    const summary = details.querySelector('summary');
    details.classList.remove('menu-opening');
    details.removeAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  };

  const openMegaMenu = (details) => {
    if (!details || !desktopMegaQuery.matches) return;
    syncSearchModalTop();
    megaMenus.forEach((menu) => {
      if (menu !== details) closeMegaMenu(menu);
    });
    const summary = details.querySelector('summary');
    details.setAttribute('open', '');
    requestAnimationFrame(() => details.classList.add('menu-opening'));
    if (summary) summary.setAttribute('aria-expanded', 'true');
  };

  megaMenus.forEach((details) => {
    let closeTimer;
    let suppressFocusOpen = false;

    details.addEventListener('pointerenter', () => {
      window.clearTimeout(closeTimer);
      openMegaMenu(details);
    });

    details.addEventListener('pointerleave', () => {
      if (!desktopMegaQuery.matches) return;
      closeTimer = window.setTimeout(() => closeMegaMenu(details), 140);
    });

    details.addEventListener('focusin', () => {
      if (suppressFocusOpen) return;
      openMegaMenu(details);
    });

    details.querySelector('[data-sw-mega-close]')?.addEventListener('click', (event) => {
      event.preventDefault();
      const summary = details.querySelector('summary');
      suppressFocusOpen = true;
      closeMegaMenu(details);
      summary?.focus();
      window.setTimeout(() => {
        suppressFocusOpen = false;
      }, 160);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !desktopMegaQuery.matches) return;
    megaMenus.forEach(closeMegaMenu);
  });

  desktopMegaQuery.addEventListener?.('change', (event) => {
    if (event.matches) return;
    megaMenus.forEach(closeMegaMenu);
  });

  const syncSearchModalTop = () => {
    const header = document.querySelector('.header');
    const headerBoundary = document.querySelector('.shopify-section-header-sticky') || header?.closest('sticky-header') || header;
    if (!headerBoundary) return;
    if (header) {
      const headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--sw-header-bottom', `${Math.round(headerBottom)}px`);
    }
    const bottom = Math.max(0, headerBoundary.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--sw-search-modal-top', `${Math.round(bottom)}px`);
  };

  if (document.querySelector('.sw-header-search-icon .header__search')) {
    document.querySelectorAll('.sw-header-search-icon .header__icon--search, .sw-mobile-header-search .header__icon--search').forEach((trigger) => {
      trigger.addEventListener('click', syncSearchModalTop);
    });
    window.addEventListener('resize', syncSearchModalTop);
    window.addEventListener('scroll', syncSearchModalTop, { passive: true });
    syncSearchModalTop();
  }

  document.querySelectorAll('#Details-menu-drawer-container > summary').forEach((trigger) => {
    trigger.addEventListener('click', () => window.requestAnimationFrame(syncSearchModalTop));
  });

  // Native details can close before HeaderDrawer's animated cleanup runs.
  // Always release its page-scroll lock when the drawer is no longer open.
  document.querySelectorAll('#Details-menu-drawer-container').forEach((drawerDetails) => {
    drawerDetails.addEventListener('toggle', () => {
      if (drawerDetails.open) return;
      const breakpoint = drawerDetails.closest('header-drawer')?.dataset.breakpoint || 'tablet';
      document.body.classList.remove(`overflow-hidden-${breakpoint}`);
      drawerDetails.classList.remove('menu-opening');
    });
  });

  document.querySelectorAll('.sw-header-search-icon details-modal, .sw-mobile-header-search details-modal').forEach((modal) => {
    const details = modal.querySelector('details');
    const predictiveSearch = modal.querySelector('predictive-search');
    const searchInput = modal.querySelector('input[type="search"]');
    const resetButton = modal.querySelector('.reset__button');

    const clearSearch = () => {
      predictiveSearch?.removeAttribute('data-sw-keep-open-on-blur');
      if (predictiveSearch && typeof predictiveSearch.close === 'function') {
        predictiveSearch.close(true);
      }
      if (searchInput) {
        searchInput.value = '';
        searchInput.setAttribute('aria-expanded', 'false');
      }
      resetButton?.classList.add('hidden');
    };

    details?.addEventListener('toggle', () => {
      if (!details.open) clearSearch();
    });

    modal.querySelector('.search-modal__close-button')?.addEventListener('click', () => {
      searchInput?.blur();
      window.setTimeout(clearSearch, 0);
    });
  });

  // Keep iOS's keyboard next-field control inside the active search experience.
  // Without this, the next eligible field is often the newsletter email input
  // in the footer, which makes the page jump while the predictive results are open.
  const mobileSearchRoots = '.sw-mobile-header-search, .sw-header-search-icon, .sw-search-bar';
  const mobileSearchOpenQuery = [
    '.sw-mobile-header-search details[open]',
    '.sw-header-search-icon details[open]',
    '.sw-search-bar predictive-search[open]',
  ].join(', ');
  const mobileSearchInputQuery = [
    '.sw-mobile-header-search input[type="search"]',
    '.sw-header-search-icon input[type="search"]',
    '.sw-search-bar input[type="search"]',
  ].join(', ');
  const mobileSearchFocusableFields = 'input:not([type="hidden"]):not([type="search"]), textarea, select';
  const mobileSearchMediaQuery = window.matchMedia('(max-width: 989px)');

  const getOpenMobilePredictiveSearch = (form) => {
    const root = form?.closest(mobileSearchRoots);
    const details = root?.querySelector('details');
    if (details && !details.open) return null;
    const predictiveSearch = root?.querySelector('predictive-search');
    return predictiveSearch?.getAttribute('results') === 'true' ? predictiveSearch : null;
  };

  const keepPredictiveResultsOpen = (predictiveSearch) => {
    if (!predictiveSearch || predictiveSearch.getAttribute('results') !== 'true') return;
    predictiveSearch.dataset.swKeepOpenOnBlur = 'true';
    if (!predictiveSearch.hasAttribute('open') && typeof predictiveSearch.open === 'function') {
      predictiveSearch.open();
    }
  };

  const syncMobileSearchKeyboardMode = () => {
    document.querySelectorAll(mobileSearchInputQuery).forEach((input) => {
      if (mobileSearchMediaQuery.matches) input.setAttribute('enterkeyhint', 'search');
      else input.removeAttribute('enterkeyhint');
    });
  };

  const syncMobileSearchFocusLock = () => {
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    const searchIsOpen = isMobile && Boolean(document.querySelector(mobileSearchOpenQuery));

    document.querySelectorAll(mobileSearchFocusableFields).forEach((field) => {
      if (field.closest(mobileSearchRoots)) return;

      if (searchIsOpen) {
        if (!field.hasAttribute('data-sw-search-original-tabindex')) {
          field.setAttribute('data-sw-search-original-tabindex', field.getAttribute('tabindex') || '');
        }
        field.setAttribute('tabindex', '-1');
        return;
      }

      if (!field.hasAttribute('data-sw-search-original-tabindex')) return;
      const originalTabindex = field.getAttribute('data-sw-search-original-tabindex');
      if (originalTabindex) field.setAttribute('tabindex', originalTabindex);
      else field.removeAttribute('tabindex');
      field.removeAttribute('data-sw-search-original-tabindex');
    });
  };

  const mobileSearchFocusObserver = new MutationObserver(syncMobileSearchFocusLock);
  mobileSearchFocusObserver.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['open'],
  });

  document.addEventListener('focusin', (event) => {
    if (!mobileSearchMediaQuery.matches) return;
    if (!document.querySelector(mobileSearchOpenQuery)) return;
    if (event.target.closest(mobileSearchRoots)) return;

    event.target.blur();
    document.querySelector(mobileSearchInputQuery)?.focus({ preventScroll: true });
  });

  document.querySelectorAll('.sw-mobile-header-search form, .sw-header-search-icon form, .sw-search-bar form').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    input?.addEventListener('input', () => {
      form.querySelector('predictive-search')?.removeAttribute('data-sw-keep-open-on-blur');
    });
    input?.addEventListener('blur', () => {
      if (!mobileSearchMediaQuery.matches) return;
      const predictiveSearch = getOpenMobilePredictiveSearch(form);
      if (!predictiveSearch || document.activeElement !== document.body) return;
      keepPredictiveResultsOpen(predictiveSearch);
    });
  });

  window.addEventListener('resize', syncMobileSearchFocusLock);
  mobileSearchMediaQuery.addEventListener?.('change', syncMobileSearchKeyboardMode);
  syncMobileSearchFocusLock();
  syncMobileSearchKeyboardMode();

  const searchBar = document.querySelector('[data-sw-search-bar]');
  if (searchBar) {
    const root = document.documentElement;
    const header = document.querySelector('.header');
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let collapsed = window.scrollY > 24;
    let ticking = false;

    root.classList.toggle('sw-search-is-collapsed', collapsed);

    const updateSearchState = () => {
      const currentScroll = window.scrollY;
      const nextCollapsed = collapsed ? currentScroll > 4 : currentScroll > 24;

      if (nextCollapsed !== collapsed) {
        collapsed = nextCollapsed;
        root.classList.toggle('sw-search-is-collapsed', collapsed);
      }

      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateSearchState);
    }, { passive: true });
  }

  document.querySelectorAll('[data-sw-size-select]').forEach((select) => {
    const formId = select.getAttribute('data-product-form-id') || select.getAttribute('form');
    const form = formId ? document.getElementById(formId) : select.closest('form');
    const container = select.closest('.product__info-container') || document;
    const submit = form ? form.querySelector('.product-form__submit') : container.querySelector('.product-form__submit');
    const submitText = submit ? submit.querySelector('span') : null;
    const variantInput = form ? form.querySelector('.product-variant-id[name="id"]') : null;
    const productForm = form.closest('product-form');
    if (!form || !submit || !submitText) return;

    const defaultText = submitText.textContent;
    const promptText = 'PLEASE SELECT A SIZE';
    const errorText = 'Please choose an available size';
    const sizeSelected = () => {
      const selectedOption = select.options[select.selectedIndex];
      return Boolean(select.value && selectedOption && !selectedOption.disabled);
    };

    const syncVariantInput = () => {
      if (!variantInput) return;
      if (sizeSelected()) {
        variantInput.disabled = false;
      } else {
        variantInput.disabled = true;
      }
    };

    const showPrompt = () => {
      if (!sizeSelected() && !submit.disabled) submitText.textContent = promptText;
    };

    const restorePrompt = () => {
      if (submitText.textContent === promptText) submitText.textContent = defaultText;
    };

    const showSizeError = () => {
      if (productForm && typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage(errorText);
        return;
      }

      const wrapper = form.querySelector('.product-form__error-message-wrapper');
      const message = wrapper ? wrapper.querySelector('.product-form__error-message') : null;
      if (wrapper && message) {
        message.textContent = errorText;
        wrapper.removeAttribute('hidden');
      }
    };

    const clearSizeError = () => {
      if (productForm && typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage(false);
        return;
      }

      const wrapper = form.querySelector('.product-form__error-message-wrapper');
      if (wrapper) wrapper.setAttribute('hidden', '');
    };

    submit.addEventListener('mouseenter', showPrompt);
    submit.addEventListener('focus', showPrompt);
    submit.addEventListener('mouseleave', restorePrompt);
    submit.addEventListener('blur', restorePrompt);
    select.addEventListener('change', () => {
      window.setTimeout(syncVariantInput, 0);
      if (sizeSelected()) clearSizeError();
      restorePrompt();
    });

    form.addEventListener('submit', (event) => {
      if (sizeSelected()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showPrompt();
      showSizeError();
      select.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      window.setTimeout(() => {
        select.focus({ preventScroll: true });
        select.click();
      }, reduceMotion ? 0 : 260);
    }, true);

    syncVariantInput();
  });

  const clickKiwiSizeChart = (container) => {
    const scope = container || document;
    const trigger = scope.querySelector(
      '[data-kiwi-sizing-chart], [data-kiwi-sizings-chart], .kiwi-sizing-chart-button, .ks-chart-modal-link, [class*="kiwi"] button, [class*="kiwi"] a, [id*="Kiwi"] button, [id*="Kiwi"] a, [id*="kiwi"] button, [id*="kiwi"] a'
    ) || document.querySelector(
      '[data-kiwi-sizing-chart], [data-kiwi-sizings-chart], .kiwi-sizing-chart-button, .ks-chart-modal-link, [class*="kiwi"] button, [class*="kiwi"] a, [id*="Kiwi"] button, [id*="Kiwi"] a, [id*="kiwi"] button, [id*="kiwi"] a'
    );
    if (!trigger) return false;
    trigger.click();
    return true;
  };

  document.querySelectorAll('[data-sw-size-guide-trigger]').forEach((button) => {
    button.addEventListener('click', () => {
      const container = button.closest('.product__info-container');
      if (clickKiwiSizeChart(container)) return;

      // KiwiSizing can inject its trigger after the product section has rendered.
      window.setTimeout(() => clickKiwiSizeChart(container), 250);
      window.setTimeout(() => clickKiwiSizeChart(container), 900);
    });
  });

  const wishlistButtons = Array.from(document.querySelectorAll('[data-sw-wishlist-button]'));
  const wishlistCountBubble = document.querySelector('[data-sw-wishlist-count-bubble]');
  const wishlistCount = document.querySelector('[data-sw-wishlist-count]');
  const wishlistCountLabel = document.querySelector('[data-sw-wishlist-count-label]');
  const wishlistGrid = document.querySelector('[data-sw-wishlist-grid]');
  const wishlistEmpty = document.querySelector('[data-sw-wishlist-empty]');
  const productUrlForHandle = (handle) => `${(window.routes && window.routes.root_url) || '/'}products/${handle}`;
  const wishlistKey = 'sw:wishlist';

  const readWishlist = () => {
    try {
      const items = JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(items) ? items.filter((item) => item && item.handle) : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    window.localStorage.setItem(wishlistKey, JSON.stringify(items));
  };

  const money = (value) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value);
    }

    return `Rs. ${(Number(value || 0) / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);

  const syncWishlistButtons = () => {
    const savedItems = readWishlist();
    const savedHandles = new Set(savedItems.map((item) => item.handle));

    wishlistButtons.forEach((button) => {
      const active = savedHandles.has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (wishlistCountBubble && wishlistCount && wishlistCountLabel) {
      const count = savedItems.length;
      wishlistCount.textContent = count > 99 ? '99+' : String(count);
      wishlistCountLabel.textContent = `${count} saved ${count === 1 ? 'product' : 'products'}`;
      wishlistCountBubble.hidden = count === 0;
    }
  };

  const removeWishlistItem = (handle) => {
    writeWishlist(readWishlist().filter((item) => item.handle !== handle));
    syncWishlistButtons();
    renderWishlistPage();
  };

  const productCardMarkup = (product, fallback) => {
    const handle = product.handle || fallback.handle;
    const url = product.url || fallback.url || (handle ? productUrlForHandle(handle) : '#');
    const title = product.title || fallback.title || handle;
    const featuredImage = product.featured_image || (product.images && product.images[0]) || '';
    const price = typeof product.price === 'number' ? product.price : null;
    const compareAtPrice = typeof product.compare_at_price === 'number' ? product.compare_at_price : null;

    return `
      <article class="sw-wishlist-item" data-sw-wishlist-item="${escapeHtml(handle)}">
        <a class="sw-wishlist-item__media" href="${escapeHtml(url)}" aria-label="${escapeHtml(title)}">
          ${featuredImage ? `<img src="${escapeHtml(featuredImage)}" alt="${escapeHtml(title)}" loading="lazy">` : ''}
        </a>
        <div class="sw-wishlist-item__info">
          <a class="sw-wishlist-item__title" href="${escapeHtml(url)}">${escapeHtml(title)}</a>
          ${price !== null ? `
            <div class="sw-wishlist-item__price">
              ${compareAtPrice && compareAtPrice > price ? `<span class="sw-wishlist-item__compare">${money(compareAtPrice)}</span>` : ''}
              <span>${money(price)}</span>
            </div>
          ` : ''}
          <button type="button" class="sw-wishlist-item__remove" data-sw-wishlist-remove="${escapeHtml(handle)}">Remove</button>
        </div>
      </article>
    `;
  };

  async function renderWishlistPage() {
    if (!wishlistGrid) return;

    const savedItems = readWishlist();
    wishlistGrid.innerHTML = '';
    wishlistGrid.setAttribute('aria-busy', 'true');

    if (!savedItems.length) {
      if (wishlistEmpty) wishlistEmpty.hidden = false;
      wishlistGrid.removeAttribute('aria-busy');
      return;
    }

    if (wishlistEmpty) wishlistEmpty.hidden = true;

    const products = await Promise.all(savedItems.map(async (item) => {
      try {
        const response = await fetch(`${productUrlForHandle(encodeURIComponent(item.handle))}.js`);
        if (!response.ok) throw new Error('Product unavailable');
        return { product: await response.json(), fallback: item };
      } catch (error) {
        return { product: {}, fallback: item };
      }
    }));

    wishlistGrid.innerHTML = products.map(({ product, fallback }) => productCardMarkup(product, fallback)).join('');
    wishlistGrid.removeAttribute('aria-busy');

    wishlistGrid.querySelectorAll('[data-sw-wishlist-remove]').forEach((button) => {
      button.addEventListener('click', () => removeWishlistItem(button.dataset.swWishlistRemove));
    });
  }

  wishlistButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const handle = button.dataset.productHandle;
      if (!handle) return;

      const savedItems = readWishlist();
      const exists = savedItems.some((item) => item.handle === handle);
      const nextItems = exists
        ? savedItems.filter((item) => item.handle !== handle)
        : [
          ...savedItems,
          {
            handle,
            url: button.dataset.productUrl || productUrlForHandle(handle),
            title: button.dataset.productTitle || handle
          }
        ];

      writeWishlist(nextItems);
      syncWishlistButtons();
      renderWishlistPage();
    });
  });

  syncWishlistButtons();
  renderWishlistPage();

  const parallaxNodes = reduceMotion ? [] : Array.from(document.querySelectorAll('[data-sw-parallax]'));
  if (parallaxNodes.length) {
    let parallaxTicking = false;

    const syncParallax = () => {
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      parallaxNodes.forEach((node) => {
        const rect = node.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (viewport - rect.top) / (viewport + rect.height)));
        node.style.setProperty('--sw-premium-progress', progress.toFixed(3));
      });
      parallaxTicking = false;
    };

    const requestParallaxSync = () => {
      if (parallaxTicking) return;
      parallaxTicking = true;
      requestAnimationFrame(syncParallax);
    };

    window.addEventListener('scroll', requestParallaxSync, { passive: true });
    window.addEventListener('resize', requestParallaxSync);
    syncParallax();
  }

  if ('IntersectionObserver' in window && !reduceMotion) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    document.querySelectorAll('[data-sw-reveal]').forEach((node) => observer.observe(node));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sw-video-sound]');
    if (!button) return;

    const section = button.closest('.sw-interactive-video');
    if (!section) return;

    const videos = Array.from(section.querySelectorAll('video'));
    const activeVideo = videos.find((video) => video.getClientRects().length > 0);
    if (!activeVideo) return;

    const shouldEnableSound = activeVideo.muted;
    videos.forEach((video) => {
      video.muted = !shouldEnableSound || video !== activeVideo;
    });

    if (shouldEnableSound) activeVideo.play().catch(() => {});
    button.setAttribute('aria-pressed', String(shouldEnableSound));
    button.setAttribute('aria-label', shouldEnableSound ? 'Turn sound off' : 'Turn sound on');
  });
})();
